import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useModuleReload } from "../moduleServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/pro-regular-svg-icons";
import { orange } from "@material-ui/core/colors";
import { useSnackAlert } from "../../../common/use-snackAlert";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typopgraphy from "@material-ui/core/Typography";

import MediaDialog from "../../common/MediaDialog";

const useStyles = makeStyles(theme => ({
  title: {
    color: orange[500],
  },

  button: {
    color: orange[500],
  },
}));

const ReloadModule = ({ id }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { SnackAlert, showAlert } = useSnackAlert();

  const reloadModule = useModuleReload();
  const handleReload = async () => {
    try {
      await reloadModule.mutateAsync({ resourceIds: { id }, data: {} });
      showAlert("success", ["Module reloaded"]);
      setOpen(false);
    } catch (err) {
      showAlert("error", [err.message]);
    }
  };
  return (
    <Fragment>
      <SnackAlert />

      <Button
        className={classes.button}
        onClick={() => setOpen(true)}
        startIcon={<FontAwesomeIcon icon={faRotateRight} />}
      >
        Reload Module
      </Button>

      <MediaDialog
        loading={reloadModule.isLoading}
        open={open}
        title="Warning!"
        titleClassName={classes.title}
        handleClose={() => setOpen(false)}
        content={
          <Typopgraphy>
            Reloading Solr is a heavy operation and should not be done
            frequently. If a module is reloaded and the issue persists, please
            wait 30 minutes before reloading again.
          </Typopgraphy>
        }
        actions={
          <Grid container justify="flex-end">
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={handleReload}>
              Reload
            </Button>
          </Grid>
        }
      />
    </Fragment>
  );
};

export default ReloadModule;
